import { render, staticRenderFns } from "./AulaImg.vue?vue&type=template&id=b5bd9eb8&scoped=true&"
import script from "./AulaImg.vue?vue&type=script&lang=js&"
export * from "./AulaImg.vue?vue&type=script&lang=js&"
import style0 from "./AulaImg.vue?vue&type=style&index=0&id=b5bd9eb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd9eb8",
  null
  
)

export default component.exports